// Hindi (India)
export default {
  translation: {
    app_name: 'Agora',
    tagline: 'जहाँ शौक समुदाय बनाते हैं',

    nav_explore: 'खोजें',
    nav_find_folks: 'लोग खोजें',
    nav_sign_in: 'साइन इन',
    nav_join_free: 'मुफ़्त जुड़ें',
    nav_sign_out: 'साइन आउट',
    nav_my_profile: 'मेरी प्रोफ़ाइल',
    nav_notifications: 'सूचनाएँ',

    auth_register: 'खाता बनाएं',
    auth_login: 'साइन इन करें',
    auth_name: 'पूरा नाम',
    auth_email: 'ईमेल पता',
    auth_password: 'पासवर्ड',
    auth_age: 'आपकी उम्र',
    auth_city: 'शहर',
    auth_building: 'सोसाइटी / कॉलोनी / बिल्डिंग का नाम',
    auth_country: 'देश',
    auth_currency: 'मुद्रा',
    auth_locale: 'भाषा और क्षेत्र',
    auth_already_have_account: 'पहले से खाता है?',
    auth_no_account: 'खाता नहीं है?',

    country_gb: 'यूनाइटेड किंगडम',
    country_us: 'अमेरिका',
    country_in: 'भारत',

    city_placeholder_gb: 'जैसे London, Manchester',
    city_placeholder_us: 'जैसे New York, Chicago',
    city_placeholder_in: 'जैसे मुंबई, दिल्ली, बेंगलुरु',
    building_placeholder_gb: 'जैसे Elm Court',
    building_placeholder_us: 'जैसे Riverside Apartments',
    building_placeholder_in: 'जैसे श्री कृष्ण सोसाइटी, DLF फेज़ 2',
    postcode_label: 'पिन कोड',
    postcode_placeholder: 'जैसे 400001',

    profile_edit: 'प्रोफ़ाइल संपादित करें',
    profile_bio: 'परिचय',
    profile_interests: 'रुचियाँ',
    profile_location: 'स्थान',
    profile_theme: 'थीम',
    profile_currency_settings: 'मुद्रा और क्षेत्र',
    profile_save: 'बदलाव सहेजें',
    profile_cancel: 'रद्द करें',

    group_join: 'समूह जुड़ें',
    group_leave: 'समूह छोड़ें',
    group_members: 'सदस्य',
    group_chat: 'चैट',
    group_events: 'कार्यक्रम',
    group_shop: 'दुकान',
    group_campaigns: 'अभियान',
    group_about: 'जानकारी',
    group_full: 'भरा हुआ',
    group_open: 'खुला',

    tip_send: 'टिप भेजें',
    tip_amount: 'टिप राशि',
    tip_message: 'संदेश (वैकल्पिक)',
    wallet_coins: 'सिक्के',
    wallet_balance: 'बैलेंस',
    tips_earned: 'अर्जित',

    event_register: 'पंजीकरण',
    event_unregister: 'रद्द करें',
    event_ticket_price: 'टिकट',
    event_free: 'मुफ़्त',
    event_capacity: 'क्षमता',
    event_registered: 'पंजीकृत',

    currency_gbp: 'ब्रिटिश पाउंड (£)',
    currency_usd: 'अमेरिकी डॉलर ($)',
    currency_inr: 'भारतीय रुपया (₹)',
    currency_symbol_gbp: '£',
    currency_symbol_usd: '$',
    currency_symbol_inr: '₹',

    locale_en_gb: 'English (UK)',
    locale_en_us: 'English (US)',
    locale_en_in: 'English (India)',
    locale_hi_in: 'हिन्दी (भारत)',

    age_group_kids: 'बच्चे (5–12)',
    age_group_teens: 'किशोर (13–17)',
    age_group_adults: 'वयस्क (18–59)',
    age_group_seniors: 'वरिष्ठ (60+)',

    theme_playful: '🎨 रंगीन',
    theme_standard: '💼 सामान्य',
    theme_accessible: '🔎 सुलभ (बड़ा टेक्स्ट)',

    notif_session_reminder: 'सत्र अनुस्मारक',
    notif_new_member: 'नए सदस्य अलर्ट',
    notif_new_buddy: 'मित्र अनुरोध अलर्ट',

    family_dashboard: 'परिवार डैशबोर्ड',
    family_link_child: 'बच्चे का खाता जोड़ें',
    family_child_email: 'बच्चे का ईमेल',
    family_gift_coins: 'सिक्के उपहार में दें',
    family_link: 'जोड़ें',

    find_folks_title: 'आस-पास के लोग खोजें',
    find_folks_desc: 'अपनी सोसाइटी में समान रुचि वाले लोगों से मिलें',
    no_results: 'कोई परिणाम नहीं मिला',
    loading: 'लोड हो रहा है…',
    error_generic: 'कुछ गड़बड़ हुई। कृपया पुनः प्रयास करें।',
  }
};
